// Gemmologischer Report im Warenkorb: Auswahl pro Stein buchen bzw. wechseln
// und Reports entfernen, deren Stein nicht mehr im Warenkorb liegt.
(function () {
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  async function post(path, body) {
    const response = await fetch(root + path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    });
    if (!response.ok) throw new Error(await response.text());
    return response.json();
  }

  document.addEventListener('change', async (event) => {
    const select = event.target.closest('.gem-report__select');
    if (!select) return;
    const box = select.closest('.gem-report');
    select.disabled = true;
    try {
      if (box.dataset.reportKey) await post('cart/change.js', { id: box.dataset.reportKey, quantity: 0 });
      if (select.value) {
        const properties = { _stein: box.dataset.stein };
        properties[box.dataset.propertyLabel || 'Für Stein'] = box.dataset.steinTitle;
        await post('cart/add.js', { items: [{ id: Number(select.value), quantity: 1, properties }] });
      }
      window.location.reload();
    } catch (error) {
      console.error(error);
      select.disabled = false;
      alert(
        document.documentElement.lang === 'de'
          ? 'Der Report konnte nicht gespeichert werden. Bitte laden Sie die Seite neu und versuchen Sie es erneut.'
          : 'The report could not be saved. Please reload the page and try again.'
      );
    }
  });

  let cleaning = false;
  async function removeOrphans() {
    const keys = [...document.querySelectorAll('[data-gem-orphan]')].map((el) => el.dataset.gemOrphan);
    if (!keys.length || cleaning) return;
    cleaning = true;
    const updates = {};
    keys.forEach((key) => (updates[key] = 0));
    try {
      await post('cart/update.js', { updates });
    } finally {
      window.location.reload();
    }
  }

  function init() {
    removeOrphans();
    const items = document.getElementById('main-cart-items');
    if (items) new MutationObserver(removeOrphans).observe(items, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
